import script from "./AddHistoricalProject.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddHistoricalProject.vue?vue&type=script&lang=ts&setup=true"

import "./AddHistoricalProject.vue?vue&type=style&index=0&id=486f9d74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-486f9d74"]])

export default __exports__